/**
 * Matching Set — show one mini-PDP card per active color.
 *
 * Each card is a self-contained product form (image + title + variant
 * dropdowns + ADD TO BAG). Theme.js's applyAjaxToProductForm auto-binds
 * the form's submit handler because the markup uses its expected hooks:
 *
 *   <div class="product-form" data-ajax-add-to-cart="true" data-product-id="...">
 *     <form class="form product-purchase-form" action="/cart/add" ...>
 *       <select name="id"> ... </select>
 *       <select name="options[Size]"> ... </select>
 *       <button type="submit">ADD TO BAG</button>
 *
 * The hidden <select name="id"> is the actual variant id that gets
 * submitted. Visible <select name="options[X]"> dropdowns drive which
 * variant gets picked. The variant options are keyed by position
 * (data-option-position) so we compare each dropdown against the right
 * index in variant.options (which always includes Color at position 0,
 * even though Color is not shown as a dropdown in this card).
 *
 * Depends on: jQuery, theme.js (applyAjaxToProductForm), and
 *             .opt-label[data-matching-handle] emitted by variant-picker-variants.liquid.
 */
(function ($) {
  'use strict';

  // The matching form wrapper does NOT use the .product-form class (it uses
  // .matching-set__form instead). Theme.js's load-product-form handler is
  // bound to $(document).on('load-product-form', '.product-form', ...) and
  // appends <span class="label__value"> to the parent PDP's swatch label on
  // every fire. By using a different class, we skip that handler entirely —
  // no append happens for the matching form, and the parent PDP's swatch
  // label is never duplicated. This prevents ColorBlackBlack.
  var $wrapper = $('.matching-set');
  if (!$wrapper.length) {
    console.log('[matching-set] no .matching-set wrapper found, skipping.');
    return;
  }

  var $cards = $wrapper.find('.matching-set__card');
  console.log('[matching-set] init', { cardCount: $cards.length });

  // Bind AJAX add-to-cart manually for each matching form. We can't rely on
  // theme.ProductTemplateSection's `load-product-form` trigger (see comment
  // above), so call theme.applyAjaxToProductForm directly on each form's
  // wrapper. The form has data-ajax-add-to-cart="true" so the drawer flow
  // activates.
  $cards.each(function () {
    var $form = $(this).find('.matching-set__form');
    if ($form.length && theme.applyAjaxToProductForm) {
      theme.applyAjaxToProductForm($form);
    }
  });

  function getActiveMatchingHandle() {
    var $checked = $('.option-name--color .opt-btn:checked').first();
    if (!$checked.length) return null;
    var $label = $checked.next('label.opt-label');
    return ($label.attr('data-matching-handle') || '').trim() || null;
  }

  // Read visible dropdowns as { position: value } so we can compare
  // against the right index in variant.options (Color is at position 0).
  function getCurrentOptionsByPosition($card) {
    var byPos = {};
    $card.find('[data-matching-option]').each(function () {
      var pos = parseInt($(this).attr('data-option-position'), 10);
      byPos[pos] = $(this).val();
    });
    return byPos;
  }

  function syncVariantForCard($card) {
    var $variantSelect = $card.find('[data-matching-variant-select]');
    if (!$variantSelect.length) return;

    var byPos = getCurrentOptionsByPosition($card);
    var posKeys = Object.keys(byPos);
    var matchedId = null;
    var firstAvailableId = null;

    // If any visible option is still on its placeholder ("Select a ..."), no match yet.
    var hasUnselected = false;
    $card.find('[data-matching-option]').each(function () {
      if (!$(this).val()) hasUnselected = true;
    });

    console.log('[matching-set] sync', { positions: posKeys, values: byPos, hasUnselected: hasUnselected });

    $variantSelect.find('option').each(function () {
      var $opt = $(this);
      var dataOpts = ($opt.attr('data-options') || '').split('||');
      var variantId = $opt.val();
      var isAvailable = !$opt.is(':disabled');

      if (isAvailable && firstAvailableId === null) {
        firstAvailableId = variantId;
      }

      if (isAvailable && dataOpts.length >= posKeys.length) {
        var match = true;
        for (var i = 0; i < posKeys.length; i++) {
          var p = parseInt(posKeys[i], 10);
          if (dataOpts[p] !== byPos[p]) { match = false; break; }
        }
        if (match) { matchedId = variantId; }
      }
    });

    var $addBtn = $card.find('.matching-set__add-to-cart');
    var $addText = $card.find('[data-add-text]');
    var addToCartLabel = (theme.strings && theme.strings.products_product_add_to_cart) || 'Add to cart';
    var soldOutLabel = (theme.strings && theme.strings.products_variant_no_stock) || 'Sold out';
    var selectLabel = 'Select options';

    if (hasUnselected) {
      // User hasn't picked every option yet — block submit, keep button visible with hint.
      $addBtn.attr('disabled', 'disabled');
      $addText.text(selectLabel);
      $variantSelect.val('');
      console.log('[matching-set] waiting for selection');
    } else if (matchedId) {
      $variantSelect.val(matchedId);
      $addBtn.removeAttr('disabled');
      $addText.text(addToCartLabel);
      console.log('[matching-set] matched variant', matchedId);
    } else if (firstAvailableId) {
      // Combination unavailable — fall back to first available variant (button disabled).
      $variantSelect.val(firstAvailableId);
      $addBtn.attr('disabled', 'disabled');
      $addText.text(soldOutLabel);
      console.log('[matching-set] no exact match, falling back to', firstAvailableId);
    } else {
      $addBtn.attr('disabled', 'disabled');
      $addText.text(soldOutLabel);
      console.log('[matching-set] no available variant');
    }
  }

  function initCard($card) {
    // Just sync the variant — no need to re-bind AJAX (bound once at init).
    syncVariantForCard($card);
  }

  function applyMatchingSet() {
    var handle = getActiveMatchingHandle();
    console.log('[matching-set] apply', { handle: handle });
    $cards.addClass('hidden');

    if (handle) {
      var $match = $wrapper.find('.matching-set__card[data-matching-handle="' + handle + '"]');
      if ($match.length) {
        $match.removeClass('hidden');
        $wrapper.removeClass('hidden');
        initCard($match);
        return;
      }
    }
    // Active color has no matching_set → hide the whole section.
    $wrapper.addClass('hidden');
  }

  // Delegated change listener — fires on every option dropdown change within the visible card.
  $(document).on('change', '.matching-set__option-select', function () {
    console.log('[matching-set] option change', $(this).attr('name'), '=', $(this).val());
    var $card = $(this).closest('.matching-set__card');
    if (!$card.length || $card.hasClass('hidden')) return;
    syncVariantForCard($card);
  });

  // Delegated change listener — fires on every swatch/radio click.
  // Runs alongside custom.js without collision because both handlers are idempotent.
  $(document).on('change', '.option-name--color .opt-btn', applyMatchingSet);

  // Initial state on DOM ready (handles SSR'd checked swatch + URL state from custom.js).
  $(function () { applyMatchingSet(); });
})(jQuery);
